import request from 'superagent';

export function buildMultipartRequest(submitUrl, csrfToken, fields, attachFiles) {
  const req = request.post(submitUrl).set('X-CSRFToken', csrfToken);
  Object.keys(fields).forEach((key) => {
    const value = fields[key];
    if (value !== null && value !== undefined) {
      req.field(key, Array.isArray(value) ? JSON.stringify(value) : String(value));
    }
  });
  if (attachFiles) {
    attachFiles(req);
  }
  return req;
}
